import SingleResponseMessage from 'owa-service/lib/contract/SingleResponseMessage';

const successClass = 'Success';

/**
 * TODO: Deprecate use of V1 from owa-mail-store module and update references
 */
export function checkIfResponseSuccessV2(response: SingleResponseMessage) {
    return response && response.ResponseClass == successClass;
}
